import axios from 'axios';
import appConfig from "./Config";

let axiosSingleton = null;

const axiosConfig = async () => {
  if (axiosSingleton) return axiosSingleton;
  const url = appConfig.drupal.host

  //const { ccpHost, token, pathApi } = ccpConfig.drupal.routes;

  try {
    const tokenResponse = await axios.get(`${url}/session/token`, {
      withCredentials: true
    });

    const csrfToken = tokenResponse.data;

    axiosSingleton = axios.create({
      baseURL: url,
      withCredentials: true,
      headers: {
        'X-CSRF-Token': csrfToken
      },
      _params: { _format: 'json' }
    });

    return axiosSingleton;
  } catch (error) {
    // @todo provide a global exception handler
    console.error(error);
    return error;
  }
};

export default axiosConfig
